<template>
   <div class="report-background">
         <table class="price-checklist">
            <template v-for="(rowData, id) in gridRowCollection">
                <thead v-if="id === 0">
                <template v-if="rowData.rowType === 'header-text'">
                    <table-row-header :row-data="rowData" :report-items="reportItems" :country="country"></table-row-header>
                </template>
                </thead>
            </template>
            <tbody>
            <template v-for="(rowData, id) in gridRowCollection">
                <template v-if="id > 0">
                    <tr v-if="rowData.rowType.startsWith('group-title-')">
                        <th :COLSPAN="noOfVisibleColumns" :class="rowData.rowType">{{rowData.categoryText}}</th>
                    </tr>
                    <template v-if="rowData.rowType === 'data-text'">
                        <table-row-content :row-data="rowData" :report-items="reportItems" :country="country"></table-row-content>
                    </template>
                    <tr v-if="rowData.rowType === 'page-break-after'">
                        <td>
                            <!--CAREFULL! THE PAGE BREAK DIV HAS TO BE ON A SEPERATE LINE OR IT WON"T WORK !!!-->
                            <div style="page-break-after: always">...</div>
                        </td>
                    </tr>
                </template>

            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            vehicles: {
                type: Array|Object,
                required: true
            },
            reportItems: {
                type: Array|Object,
                required: true
            },
            country: {
                type: String,
                required: false
            },
            rowsPerPage: {
                type: Number,
                default: 35,
            }
        },
        data () {
            return {
                groupItems: ['brands__name', 'local_versions__catalog_category', 'models__name'],
                hiddenItems: '',
                rowsInserted: 0,
            }
        },
        computed: {
            maxRowsPerPage: function () {
                return this.rowsPerPage;
            },
            gridRowCollection: function () {
                return this.getGridRowCollection(this.vehicles, this.groupItems, this.maxRowsPerPage)
            },
            noOfVisibleColumns: function () {
                let noOfItems = Object.keys(this.reportItems).length;
                let noOfHiddenItems = 0;
                for (const [itemName, itemObject] of Object.entries(this.reportItems)) {
                    if (itemObject.hidden) {
                        noOfHiddenItems++
                        // noOfHiddenItems = itemObject.hidden
                    }
                }
                return noOfItems - noOfHiddenItems;
            }
        },
        methods: {
            getGridRowCollection: function (vehicles, groupItems, maxRowsInPage) {
                let tableRows = [];
                let tableRowIndex = 0;
                let noOfRowsInPage = 0;
                let previousGroupValues = [];
                if (vehicles) {
                    for (let i = 0, len = vehicles.length; i < len; i++) {
                        if (vehicles[i]) {
                            /** Set the vehicle data in the row object */
                            let vehicle = vehicles[i];
                            /** Check if a header row is required */
                            if (noOfRowsInPage === 0 || noOfRowsInPage >= maxRowsInPage) {
                                tableRows.push({vehicle: vehicles[i], rowType: 'header-text', categoryText: ''});
                                tableRowIndex++;
                            }
                            /** Get group-field values and compare with previous row */
                            if (groupItems) {
                                for (let g = 0, len = groupItems.length; g < len; g++) {
                                    /** Prep the previous value memory */
                                    if (typeof previousGroupValues[g] === 'undefined') {
                                        previousGroupValues.push('');
                                    }
                                    /** Get the current vehicles group item value and compare it to the previous one */
                                    if (vehicle[groupItems[g]] !== previousGroupValues[g]) {
                                        /** If the value is different from the previous one then insert a category row */
                                        previousGroupValues[g] = vehicle[groupItems[g]];
                                        tableRows.push({vehicle: vehicles[i], rowType: 'group-title-' + (g+1), categoryText: vehicle[groupItems[g]]});
                                        tableRowIndex++;
                                        noOfRowsInPage++;
                                    }
                                }
                            }
                            /** Set the vehicle data row */
                            tableRows.push({vehicle: vehicles[i], rowType: 'data-text', categoryText: ''});
                            tableRowIndex++;
                            noOfRowsInPage++;
                            /** Check if a page break is required  */
                            if (noOfRowsInPage >= maxRowsInPage) {
                                tableRows.push({vehicle: vehicles[i], rowType: 'page-break-after', categoryText: ''});
                                tableRowIndex++;
                                noOfRowsInPage = 0;
                            }
                        }
                    }
                }
                return tableRows;
            }
        }
    }
</script>

<style scoped>

</style>
